import React from 'react'

import { CCol } from '@coreui/react-pro'

import '../styles/loginStyles.scss'

const LeftSide = () => {
  return (
    <CCol md={3} className="d-flex column loginLeftContainer d-none d-lg-block">
      <CCol style={{ position: 'absolute', bottom: 0, width: '100%', height: '100%' }}>
        <div
          style={{
            borderTopRightRadius: '100%',
            position: 'absolute',
            height: '40%',
            width: '100%',
            backgroundColor: 'white',
            bottom: 0,
            padding: '1rem',
            paddingRight: '5rem',
          }}
        >
          <img
            src={require('@assets/images/login-sketch.png')}
            alt={'login-sketch'}
            style={{
              marginTop: '-50%',
              width: '100%',
              padding: '0.5rem',
              paddingRight: '4rem',
            }}
          />
          <div className="body-large-italic-font mt-4">
            &quot;Being able to easily send and review worksheets with the clients in our practice
            has been such an appreciated process for both the client and the therapists. The
            worksheets are concise, evidence-driven, and best of all, user friendly.&quot;
            <div>Alicia Murray, LPC</div>
          </div>
        </div>
      </CCol>
    </CCol>
  )
}

export default LeftSide
